module.exports = __webpack_public_path__ + "static/media/organic.bd9b60d6.png";